// productsServices.js
import api from "./api";

// 🔹 Obtener todos los productos (modo general)
export async function getAllProducts(pageNumber = 1) {
  try {
    // Agregamos '?page=...' a la URL
    const response = await api.get(`products/allproductsgeneral/?page=${pageNumber}`);
    // response.data será un objeto { page, total_pages, has_next, has_previous, results }
    return response.data;
  } catch (error) {
    console.error("Error al obtener productos:", error);
    return null;
  }
}

// 🔍 Buscar productos con término + ID de inventario fijo
export const getProductsBySearch = async (searchQuery) => {
  try {
    const response = await api.get("/products/search/view/", {
      params: {
        q: searchQuery,
        FIInventario: 1, // TODO: parametrizar si se requiere dinámico
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener productos de la búsqueda:", error);
    return null;
  }
};

// 💰 Filtrar productos por precio mínimo y máximo
export const getProductsPrice = async (minPrice = null, maxPrice = null) => {
  try {
    const params = {};
    if (minPrice !== null) params.min_price = minPrice;
    if (maxPrice !== null) params.max_price = maxPrice;

    const response = await api.get("/products/filter/price/", { params });
    return response.data;
  } catch (error) {
    console.error("Error al obtener productos filtrados por precio:", error);
    return null;
  }
};



// Filtrar productos por coincidencias "marca" y "nombre"
export const getProductsSearch = async (searchTerm = "") => {
  try {
    const params = {};
    //console.log("🔍 Buscando productos con término:", searchTerm); // 👈 Consola cuando buscas
    if (searchTerm.trim() !== "") params.search = searchTerm;  // 👈 enviamos el parámetro 'search'

    const response = await api.get("/products/filter/search/", { params });
    console.log("🔍 Respuesta de búsqueda de productos:", response.data); // 👈 Consola de respuesta
    return response.data;
  } catch (error) {
    console.error("Error al buscar productos:", error);
    return null;
  }
};

/**
 * ============================ SERVICIO UNIFICADO =============================
 *
 * getFilteredProducts recibe un objeto con:
 *   - searchText   : string   (término libre a buscar en nombre/marca/categorías)
 *   - minPrice     : number   (precio mínimo deseado)
 *   - maxPrice     : number   (precio máximo deseado)
 *   - selectedBrands: array  (IDs o nombres de marca, ej: [1,4,7] o ["Nike","Puma"])
 *   - page         : number   (número de página, 1-based; cada página devuelve 45 resultados)
 *
 * Hace una sola llamada GET a "/products/filter/" con los query‐params adecuados.
 * La respuesta debe ser un arreglo de productos (45 máx por página, al azar).
 */
export const getFilteredProducts = async ({
  searchText = "",
  minPrice = null,
  maxPrice = null,
  selectedBrands = [],
  page = 1,
}) => {
  try {
    const params = {};

    // 1) Texto de búsqueda
    if (searchText && searchText.trim() !== "") {
      params.q = searchText.trim();
    }

    // 2) Rango de precios
    if (minPrice !== null && minPrice !== "") {
      params.min_price = minPrice;
    }
    if (maxPrice !== null && maxPrice !== "") {
      params.max_price = maxPrice;
    }

    // 3) Marcas (lista coma-separada)
    if (Array.isArray(selectedBrands) && selectedBrands.length > 0) {
      // Si tu backend espera IDs numéricos de marca:
      //    params.marcas = "1,4,7"
      // Si se filtra por nombre de marca:
      //    params.marcas = "Nike,Puma"
      // Ajusta según tu implementación en Django.
      params.marcas = selectedBrands.join(",");
    }

    // 4) Paginación
    if (page && page > 1) {
      params.page = page;
    }

    const response = await api.get("/products/filter/", { params });
    // response.data debería ser un arreglo de productos JSON
    return response.data;
  } catch (error) {
    console.error("Error al obtener productos filtrados:", error);
    return [];
  }
};


// 🔹 Detalles públicos de producto (sin autenticación)
export async function getProductDetailsPublic(fiProducto) {
  try {
    // 1) Solicitud GET a Django: solo enviamos FIProducto como query param
    const response = await api.get("/products/details/public/", {
      params: { FIProducto: fiProducto }
    });
    return response.data;
  } catch (error) {
    console.error("Error en getProductDetailsPublic:", error);
    throw error;
  }
}

// 📦 Obtener productos por ID de inventario (autenticado)
export const getProductsByInventory = async (FIInventario) => {
  try {
    const response = await api.get("/products/inventory", {
      params: { FIInventario },
    });
    //console.log("✅ Productos por inventario:", response.data);
    return response.data;
  } catch (error) {
    console.error(`❌ Error al obtener productos del inventario ${FIInventario}:`, {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message,
    });
    // Para que el componente detecte el fallo y muestre mensaje de error:
    throw new Error('Error al obtener productos del inventario.');
  }
};

// 🔄 Obtener historial de movimientos de productos por inventario
export const getInventoryMovements = async (FIInventario) => {
  try {
    const response = await api.get("/products/movements/history/", {
      params: { FIInventario },
    });
    if (response.data.success) {
      return response.data.movimientos;
    }
    return [];
  } catch (error) {
    console.error("Error al obtener historial de movimientos:", error);
    return [];
  }
};
